/**
 * Een aantal met het juiste woord erachter: '1 organisatie', '3 organisaties'.
 * Eén plek voor de hele Intelligence-module; stond als tien gelijke kopieën.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {number} n
 * @param {string} enkel - Vorm bij precies één
 * @param {string} meer - Vorm bij elk ander aantal
 * @returns {string}
 */
const telwoord = (n, enkel, meer) => `${n} ${n === 1 ? enkel : meer}`

export default telwoord
